import { combineReducers } from "redux";
import reducerData from "./reducer-data";
import reducerParameters from "./reducer-parameters";
import reducerTco from "./reducer-tco";
import reducerInitialTco from "./reducer-initial-tco";
import reducerLanguage from "./reducer-language";

export const mainReducer = combineReducers({
    reducerData,
    reducerParameters,
    reducerTco,
    reducerInitialTco,
    reducerLanguage,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js